import React, { useState } from "react";
import { FormFieldSet } from "../../../../../components";
import { PHONE_NEW_PROPS, PHONE_PROPS, PropsTable } from "./Props/Props";

const CATEGORIES = {
  core: { label: "Core", color: "#EFF6FF", textColor: "#1D4ED8" },
  display: { label: "Display", color: "#F0FDF4", textColor: "#15803D" },
  behavior: { label: "Behavior", color: "#FFFBEB", textColor: "#B45309" },
};


const PhoneList = () => {
  const [phone, setPhone] = useState("");
  const [phoneDisabled, setPhoneDisabled] = useState("");
  const [phoneFilled, setPhoneFilled] = useState("868874545");
  const [phoneFilledDisabled, setPhoneFilledDisabled] = useState("868874545");

  const [phoneNew, setPhoneNew] = useState([]);
  const [phoneNewDisabled, setPhoneNewDisabled] = useState([]);
  const [phoneNewFilled, setPhoneNewFilled] = useState([
    {
      code: "+91",
      number: "8688740909",
    },
  ]);
  const [phoneNewFilledDisabled, setPhoneNewFilledDisabled] = useState([
    {
      code: "+91",
      number: "8688740909",
    },
  ]);

  const handlePhoneChange = (fullValue, details) => {
    setPhone(details.number);
  };

  const handlePhoneFilledChange = (fullValue, details) => {
    setPhoneFilled(details.number);
  };

  return (
    <>
      <div className="grid grid-cols-4 gap-5 my-5">
        <div>
          <FormFieldSet
            title="Phone"
            type="phone"
            placeholder="Enter Mobile Number"
            value={phone}
            onChange={handlePhoneChange}
          />
        </div>
        <div>
          <FormFieldSet
            title="Phone"
            type="phone"
            placeholder="Enter Mobile Number"
            value={phoneDisabled}
            onChange={(e) => setPhoneDisabled(e)}
            disabled
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            title="Phone"
            type="phone"
            placeholder="Enter Mobile Number"
            value={phoneFilled}
            onChange={handlePhoneFilledChange}
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            title="Phone"
            type="phone"
            placeholder="Enter Mobile Number"
            value={phoneFilledDisabled}
            onChange={(e) => setPhoneFilledDisabled(e)}
            disabled
          />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-5 my-5 mb-20">
        <div>
          <FormFieldSet
            title="Phone New"
            type="phoneNew"
            placeholder="Enter Mobile Number"
            values={phoneNew}
            onChange={setPhoneNew}
          />
        </div>
        <div>
          <FormFieldSet
            title="Phone New"
            type="phoneNew"
            placeholder="Enter Mobile Number"
            values={phoneNewDisabled}
            onChange={setPhoneNewDisabled}
            disabled
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            title="Phone New"
            type="phoneNew"
            placeholder="Enter Mobile Number"
            values={phoneNewFilled}
            onChange={setPhoneNewFilled}
            shadow={true}
          />
        </div>
        <div>
          <FormFieldSet
            title="Phone New"
            type="phoneNew"
            placeholder="Enter Mobile Number"
            values={phoneNewFilledDisabled}
            onChange={setPhoneNewFilledDisabled}
            disabled
          />
        </div>
      </div>

    
      <PropsTable
        data={PHONE_PROPS}
        title="Phone — Props Reference"
        typeLabel='type="Phone"'
        categories={CATEGORIES}
      />

      <div className="mt-4 bg-info-50 border border-info-200 rounded-lg p-4 text-xs text-info-900">
        <p className="font-medium mb-2">phone onChange — two arguments</p>
        <pre className="bg-info-100 rounded p-2 text-xs leading-relaxed overflow-x-auto">{`const handlePhoneChange = (fullValue, details) => {
  // fullValue  → "+918688740909"  (full string with country code)
  // details    → {
  //   countryCode: "+91",
  //   number:      "8688740909",   ← just the digits
  //   fullNumber:  "+918688740909",
  //   flag:        "🇮🇳",
  //   error:       null | "error message"
  // }
  setPhone(details.number);
};`}</pre>
      </div>

      <PropsTable
        data={PHONE_NEW_PROPS}
        title="Phone New — Props Reference"
        typeLabel='type="phoneNew"'
        categories={CATEGORIES}
      />

      <div className="mt-4 bg-amber-50 border border-amber-200 rounded-lg p-4 text-xs text-amber-900">
        <p className="font-medium mb-2">
          ⚠ phone vs phoneNew — key differences
        </p>
        <table className="w-full text-xs text-amber-900">
          <thead>
            <tr className="border-b border-amber-200">
              <th className="text-left py-1 pr-4 font-medium">Point</th>
              <th className="text-left py-1 pr-4 font-medium">phone</th>
              <th className="text-left py-1 font-medium">phoneNew</th>
            </tr>
          </thead>
          <tbody className="leading-relaxed">
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">Value prop</td>
              <td className="py-1 pr-4">
                <code className="bg-amber-100 px-1 rounded">value</code> —
                string
              </td>
              <td className="py-1">
                <code className="bg-amber-100 px-1 rounded">values</code> —
                array of objects
              </td>
            </tr>
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">onChange receives</td>
              <td className="py-1 pr-4">
                Two args: fullValue + details object
              </td>
              <td className="py-1">Updated array directly</td>
            </tr>
            <tr className="border-b border-amber-100">
              <td className="py-1 pr-4 font-medium">Multiple numbers</td>
              <td className="py-1 pr-4">Single number only</td>
              <td className="py-1">
                Supports multiple via{" "}
                <code className="bg-amber-100 px-1 rounded">multiple</code> prop
              </td>
            </tr>
            <tr>
              <td className="py-1 pr-4 font-medium">Validation</td>
              <td className="py-1 pr-4">Built-in — error in details object</td>
              <td className="py-1">Basic — only digits accepted</td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PhoneList;
